<template>
  <div class="courses-container">
    <h4 class="fw-600">This course includes:</h4>
    <div>
      <div class="flex justify-space-between mb-20">
        <div>
          <img class="mr-10" :src="icons.TimeIcon" alt="" />
          <span style="color:#757F8F; font-size:14px">Course Duration</span>
        </div>
        <span style="color:#757F8F; font-size:14px">{{
          info.content_info
        }}</span>
      </div>
      <div class="flex justify-space-between mb-20">
        <div>
          <img class="mr-10" :src="icons.Vecter1" alt="" />
          <span style="color:#757F8F; font-size:14px">Category</span>
        </div>
        <span style="color:#757F8F; font-size:14px">Graphics Designe</span>
      </div>
      <div class="flex justify-space-between mb-20">
        <div>
          <img class="mr-10" :src="icons.Vecter2" alt="" />
          <span style="color:#757F8F; font-size:14px">Course Level</span>
        </div>
        <span style="color:#757F8F; font-size:14px">{{
          info.instructional_level
        }}</span>
      </div>
      <div class="flex justify-space-between mb-20">
        <div>
          <img class="mr-10" :src="icons.Vecter3" alt="" />
          <span style="color:#757F8F; font-size:14px">Student Enrolled</span>
        </div>
        <span style="color:#757F8F; font-size:14px">{{
          formatNumber(info.num_subscribers)
        }}</span>
      </div>
      <div class="flex justify-space-between mb-20">
        <div>
          <img class="mr-10" :src="icons.Vecter4" alt="" />
          <span style="color:#757F8F; font-size:14px">Last Update</span>
        </div>
        <span style="color:#757F8F; font-size:14px">{{
          formatDate(info.created_at)
        }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import VideoPoster from "@/assets/img/img_edu/Video.png";
import TimeIcon from "@/assets/img/svg_edu/TimeIcon.svg";
import Vecter1 from "@/assets/img/svg_edu/Vector1.svg";
import Vecter2 from "@/assets/img/svg_edu/Vector2.svg";
import Vecter3 from "@/assets/img/svg_edu/Vector3.svg";
import Vecter4 from "@/assets/img/svg_edu/Vector4.svg";
import { formatNumber, formatDate } from "@/utils/formatData";

export default {
  name: "describe-courses",
  props: {
    info: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {},
  created() {},
  data() {
    return {
      img: {
        VideoPoster
      },
      icons: {
        TimeIcon,
        Vecter1,
        Vecter2,
        Vecter3,
        Vecter4
      }
    };
  },
  watch: {},
  methods: {
    formatNumber,
    formatDate
  }
};
</script>
<style scoped>
.search-course {
  padding: 3px 0;
  background: #f5f9ff;
}
.courses-container {
}
.main-view {
  padding-top: 100px;
}
</style>
